import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";
import ShopArchive from "./ShopArchive";
import { shopArchiveURIs } from "./variables";

const App: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path={shopArchiveURIs.home} element={<ShopArchive />} />
          <Route
            path={`${shopArchiveURIs.home}/page/:pageNum`}
            element={<ShopArchive />}
          />
          <Route
            path={`${shopArchiveURIs.genre}:genreSlug`}
            element={<ShopArchive />}
          />
          <Route
            path={`${shopArchiveURIs.genre}:genreSlug/page/:pageNum`}
            element={<ShopArchive />}
          />
          <Route
            path={`${shopArchiveURIs.search}:searchText`}
            element={<ShopArchive />}
          />
          <Route
            path={`${shopArchiveURIs.search}:searchText/page/:pageNum`}
            element={<ShopArchive />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
